import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {UserSettings} from 'app/global/user-settings.dto';
import {Observable} from 'rxjs';
import {currentUserId, selectUserSetting} from './reducers/user_settings.reducer';

@Injectable({
    providedIn: 'root'
})

export class UserSettingsFacade {

    public _userSettings$: Observable<UserSettings> = this._store$.select(selectUserSetting);
    public currentUserId$: Observable<number> = this._store$.select(currentUserId);

    constructor (private _store$: Store) {}
}
